import { z } from 'zod';

/**
 * `GET /voll-wallet/audit` — o "Bloqueio Expense Audit" do app legado: com alguma prestação de
 * contas aberta pelo agente de auditoria, Pix e reembolso ficam pausados até o viajante
 * responder por e-mail. `vouchers` são os pedidos em questão (código e nome).
 */
export const VollWalletAuditSchema = z
  .object({
    blocked: z.boolean(),
    vouchers: z.array(z.object({ code: z.string().min(1), name: z.string().nullable() }).strict()),
  })
  .strict();
export type VollWalletAudit = z.infer<typeof VollWalletAuditSchema>;
